const isChineseUser = () => {
  const lang = navigator.language || navigator.userLanguage;
  const isCNLang = lang.includes('zh-CN') || lang.includes('zh');
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const isCNTimezone = timezone.includes('Asia/Shanghai') || timezone.includes('China');
  
  return isCNLang || isCNTimezone;
};

if (isChineseUser()) {
  window.location.href = 'https://www.raleighdresses.com/collections/prom-dresses';
}